import dayjs from "dayjs";
import "dayjs/locale/vi";
import weekday from "dayjs/plugin/weekday";
import isoWeek from "dayjs/plugin/isoWeek";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";
import relativeTime from "dayjs/plugin/relativeTime";
import localizedFormat from "dayjs/plugin/localizedFormat";
import duration from "dayjs/plugin/duration";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(duration);
dayjs.extend(localizedFormat);
dayjs.extend(weekday);
dayjs.extend(isoWeek);
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(isToday);
dayjs.extend(isYesterday);
dayjs.extend(relativeTime);
dayjs.extend(timezone);

// Set Vietnamese locale
dayjs.locale('vi');

export const LOCALE = {
  Mon: "Th2",
  Tue: "Th3",
  Wed: "Th4",
  Thu: "Th5",
  Fri: "Th6",
  Sat: "Th7",
  Sun: "CN",
};
export const LOCALE_SHORT = {
  Mon: "T2",
  Tue: "T3",
  Wed: "T4",
  Thu: "T5",
  Fri: "T6",
  Sat: "T7",
  Sun: "CN",
};
export const DAY_OF_WEEK_MAP = {
  T2: "mon",
  Th2: "mon",
  T3: "tue",
  Th3: "tue",
  T4: "wed",
  Th4: "wed",
  T5: "thu",
  Th5: "thu",
  T6: "fri",
  Th6: "fri",
  T7: "sat",
  Th7: "sat",
  CN: "sun",
};
export const DAY_OF_WEEK_MAP_REVERSE = {
  mon: "Th2",
  tue: "Th3",
  wed: "Th4",
  thu: "Th5",
  fri: "Th6",
  sat: "Th7",
  sun: "CN",
};
export const toUTCString = (date: any) => {
  if (!date) return dayjs.utc().toISOString();
  if (typeof date.format === 'function') {
    return dayjs.utc(date.format("YYYY-MM-DD HH:mm:ss")).toISOString();
  }
  return dayjs.utc(date).toISOString();
};

export default dayjs;
